import { useQuery } from '@tanstack/react-query'
import { statsApi } from '~/entities/stats/api/stats'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'

/** The Rückblick numbers of an event; asked only once the event is over. */
export function useEventSummary(businessId: string, eventId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKey(QueryKey.EVENT_SUMMARY, eventId),
    queryFn: () => statsApi.getEventSummary(businessId, eventId),
    staleTime: 5 * MINUTES,
    enabled: enabled && !!businessId && !!eventId,
  })
}
